<template>
	<!-- star -->

	<div class="homepage_wrap" ref="myElement">
		<!-- banner图和导航栏 -->
		<div class="banner_nav">
			<swiper ref="mySwiper1" :options="swiperData">
				<swiper-slide v-for='(item, index) in swiperListData' :key='index'>
					<img :src="item.src" alt="">
					<!-- <div class="banner-title">
						<h1>{{item.title}}</h1>
						<p>{{item.english}}</p>
					</div> -->
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
				<!-- <div class="swiper-button-prev" slot="button-prev"></div>
				<div class="swiper-button-next" slot="button-next"></div> -->
			</swiper>
			
			<!-- title -->
			<div class="banner_title_wrap">
				<div class="banner_title_center">
					<p>{{ title }}</p>
					<div>科技创新引领产业发展 <span>·</span>产教融合共育技术人才</div>
				</div>
			</div>
		</div>

		<!-- 产品服务 v-show="tabbarBoxFixed1" -->
		<div class="services-view page1" id="history">
			<div class="DevelopmentHistory_cont">
				<div class="com-title animate__animated" :class="tabbarBoxFixed1 ? 'animate__fadeInDown' : 'animate__fadeOutUp'">
					<h3>产品服务
						<p>INTELLIGENT PRODUCTS</p>
					</h3>
				</div>
				<div class="services-center">
					<div class="services-cell">
						<ul class="services-ul fx fw">
							<li class="services-li animate__animated" :class="tabbarBoxFixed1 ? 'animate__slideInLeft' : 'animate__slideOutLeft'">
								<a href="#">
									<img src="@/assets/img/01.jpg" alt="" />
									<div class="inner">
										<h3>电力抢修 </h3>
										<p>24小时电力抢修</p>
									</div>
								</a>
							</li>
							<li class="services-li animate__animated" :class="tabbarBoxFixed1 ? 'animate__fadeInDown' : 'animate__fadeOutUp' ">
								<a href="#">
									<img src="@/assets/img/02.jpg" alt=""/>
									<div class="inner">
										<h3>电力运维</h3>
										<p>设备运行维护保</p>
									</div>
								</a>
							</li>
							<li class="services-li animate__animated" :class="tabbarBoxFixed1 ? 'animate__fadeInDown' : 'animate__fadeOutUp' ">
								<a href="#">
									<img src="@/assets/img/03.jpg" alt=""/>
									<div class="inner">
										<h3>电力巡检</h3>
										<p>排查故障及隐患</p>
									</div>
								</a>
							</li>
							<li class="services-li animate__animated" :class="tabbarBoxFixed1 ? 'animate__fadeInUp' : 'animate__fadeOutDown'">
								<a href="#">
									<img src="@/assets/img/04.jpg" alt=""/>
									<div class="inner">
										<h3>配电改造</h3>
										<p>按需求现场勘察</p>
									</div>
								</a>
							</li>
							<li class="services-li animate__animated" :class="tabbarBoxFixed1 ? 'animate__fadeInUp' : 'animate__fadeOutDown'">
								<a href="#">
									<img src="@/assets/img/05.jpg" alt="" />
									<div class="inner">
										<h3>带电检测</h3>
										<p>配电设备检测</p>
									</div>
								</a>
							</li>
							<li class="services-li animate__animated" :class="tabbarBoxFixed1 ? 'animate__slideInRight' : 'animate__slideOutRight'">
								<a href="#">
									<img src="@/assets/img/06.jpg" alt=""/>
									<div class="inner">
										<h3>电力设备</h3>
										<p>预防性试验</p>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<!-- 选择我们 v-show="tabbarBoxFixed2"-->
		<div class="solve page2">
            <div>
				<div class="com-title animate__animated" :class="tabbarBoxFixed2 ? 'animate__fadeInDown' : 'animate__fadeOutUp'">
					<h3>选择我们
						<p>CHOOSE US</p>
					</h3>
				</div>
				<div class="solver-container">
					<div class="main-center w-body">
						<div class="tabBoxs fx fw animate__animated" :class="tabbarBoxFixed2 ? 'animate__fadeInUp' : 'animate__fadeOutDown'">
							<div class="solve-item w25 bl bb">
								<div class="small-box">
									<h3>快速响应</h3>
									<p>我们提供24小时电力抢修服务，半小时到达现场。我们的专业团队将根据您的需求提出解决方案，并在获得您的同意后尽快处置故障，确保应急恢复供电的首要目标得以实现。</p>
									<div class="sol-b fx ac jsb">
										<div class="icon">
											<i class="iconfont icon-jiejuefangan"></i>
										</div>
										<a href="/product#pro-1" class="more" onclick="sloveLink()">立即咨询 <i class="iconfont icon-jiejuefangan "></i></a>
									</div>
								</div>
								<div class="hover-box">
									<h3>快速响应</h3>
									<p>我们提供24小时电力抢修服务，半小时到达现场。我们的专业团队将根据您的需求提出解决方案，并在获得您的同意后尽快处置故障，确保应急恢复供电的首要目标得以实现。</p>
									<a href="/product#pro-1" class="more">立即咨询 <i class="iconfont icon-tuxing "></i></a>
								</div>
							</div>
							<div class="solve-item w25 bl bb">
								<div class="small-box">
									<h3>精准勘察</h3>
									<p>我们将根据您的实际需求进行现场勘察，并提供精准的解决方案和报价，确保您的配电设备得到最佳的改造和升级，提高运行效率，保证电力供应的可靠性。</p>
									<div class="sol-b fx ac jsb">
										<div class="icon">
											<i class="iconfont icon-dashujuxingyegailan"></i>
										</div>
										<a href="/product#pro-1" class="more" onclick="sloveLink()">立即咨询 <i class="iconfont icon-tuxing "></i></a>
									</div>
								</div>
								<div class="hover-box">
									<h3>精准勘察</h3>
									<p>我们将根据您的实际需求进行现场勘察，并提供精准的解决方案和报价，确保您的配电设备得到最佳的改造和升级，提高运行效率，保证电力供应的可靠性。</p>
									<a href="/product#pro-1" class="more">立即咨询 <i class="iconfont icon-tuxing "></i></a>
								</div>
							</div>
							<div class="solve-item w25 bl bb">
								<div class="small-box">
									<h3>专业运维</h3>
									<p>我们提供配电设备的运行维护保养和故障维修服务，包括高低压开关柜、变压器等设备。我们的专业技术团队将为您提供高效的服务，确保设备得到及时的维护和保养，减少故障和停机时间，提高运行效率。</p>
									<div class="sol-b fx ac jsb">
										<div class="icon">
											<i class="iconfont icon-5_7shuziluanshenggongchang"></i>
										</div>
										<a href="/product#pro-2" class="more">立即咨询 <i class="iconfont icon-tuxing "></i></a>
									</div>
								</div>
								<div class="hover-box">
									<h3>专业运维</h3>
									<p>我们提供配电设备的运行维护保养和故障维修服务，包括高低压开关柜、变压器等设备。我们的专业技术团队将为您提供高效的服务，确保设备得到及时的维护和保养，减少故障和停机时间，提高运行效率。</p>
									<a href="/product#pro-2" class="more">立即咨询 <i class="iconfont icon-tuxing "></i></a>
								</div>
							</div>
							<div class="solve-item w25 bl bb br">
								<div class="small-box">
									<h3>周期巡检</h3>
									<p>我们提供配电房巡视和安全隐患排查服务，并提供巡检报告。对于售电用户，我们的巡检服务是免费的。我们将确保您的电力设备始终处于最佳状态，安全稳定运行。</p>
									<div class="sol-b fx ac jsb">
										<div class="icon">
											<i class="iconfont icon-qiyeguanli"></i>
										</div>
										<a href="/product#pro-3" class="more">立即咨询 <i class="iconfont icon-tuxing "></i></a>
									</div>          
								</div>
								<div class="hover-box">
									<h3>周期巡检</h3>
									<p>我们提供配电房巡视和安全隐患排查服务，并提供巡检报告。对于售电用户，我们的巡检服务是免费的。我们将确保您的电力设备始终处于最佳状态，安全稳定运行。</p>
									<a href="/product#pro-3" class="more">立即咨询 <i class="iconfont icon-tuxing "></i></a>
								</div>
							</div>
							<div class="solve-item w25 bl">
								<div class="small-box">
									
								</div>
							</div>
							<div class="solve-item w25 bl">
								<div class="small-box">
									
								</div>
							</div>
							<div class="solve-item w25 bl">
								<div class="small-box">
									
								</div>
							</div>
							<div class="solve-item w25 bl br">
								<div class="small-box">
									
								</div>
							</div>                        
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 智能设备  v-show="tabbarBoxFixed4"-->
		<div class="DevelopmentHistory page4" id="history">
			<div class="DevelopmentHistory_cont">
				<div class="com-title animate__animated" :class="tabbarBoxFixed4 ? 'animate__fadeInDown' : 'animate__fadeOutUp'">
					<h3>智能设备
						<p>INTELLIGENT PRODUCTS</p>
					</h3>
				</div>
				<div class="elegant-center products-view animate__animated" :class="tabbarBoxFixed4 ? 'animate__flipInX' : 'animate__flipOutX' ">
					<div class="elegant-img">
						<swiper ref="mySwiper2" :options="swiperOptions2">
							<swiper-slide v-for='(item, index) in swiperList1' :key='index'>
								<div class="slide-view">
									<div class="img-dev"><img :src="item.src" alt=""></div>
									<div class="products-text">
										<div class="subtitle" data-swiper-parallax="-200">{{item.name}}</div>
										<div class="text" data-swiper-parallax="-100">
											<p>
												{{item.introduce}}
											</p>
										</div>
									</div>
								</div>
							</swiper-slide>
							<div class="swiper-button-prev" slot="button-prev"></div>
							<div class="swiper-button-next" slot="button-next"></div>
						</swiper>
					</div>
				</div>
				<!-- <button class="whole-btn">查看全部</button> -->
				<router-link to="product" class="whole-btn">查看全部</router-link>
			</div>
		</div>

		

		<!-- 智能云平台 v-show="tabbarBoxFixed3" -->
		<div class="core-product page3">
			<div class="main-center w-body">
				<div class="com-title animate__animated" :class="tabbarBoxFixed3 ? 'animate__fadeInDown' : 'animate__fadeOutUp'">
					<h3>智能云平台
						<p>CORE PRODUCTS</p>
					</h3>
				</div>
				<div class="cor-tabs animate__animated" :class="tabbarBoxFixed3 ? 'animate__rollIn' : 'animate__rollOut'">
					<ul class="fx jcc">
						<li @click="cur=0" :class="{'core-active':cur==0}">变压器监控运维</li>
						<li @click="cur=1" :class="{'core-active':cur==1}">电力信息化</li>
						<li @click="cur=2" :class="{'core-active':cur==2}">电缆安全监测</li>
					</ul>
				</div>
			  	<div class="core-container">
				  	<div class="core-box" :class="{'core-selected':cur==0}">
					  	<div class="core-item">
							<div class="core-l animate__animated" :class="tabbarBoxFixed3 ? 'animate__slideInLeft' : 'animate__slideOutLeft'">
								<h3>“变压器监控运维” 平台</h3>
								<p>
									“变压器监控运维平台”是针对变压器（干式 / 油式）运行状态进行监测而研发的一套可视化
									系统，具有用电数据（电压、电流、功率、功率因数、电量，最大需量、电费等）采集、温度监测、
									故障报警和远程运维等功能。变压器监控运维平台对变压器设备运维的全面升级，综合应用物联网云计算、大数据、人工智
									能、移动互联网技术，为变压器设备全生命周期运维管理提供信息化支撑
								</p>
								<a href="#" class="core-jt" @click.prevent="handleClick1"><i class="iconfont icon-jiantou"></i></a>
							</div>
							<div class="cor-r animate__animated" :class="tabbarBoxFixed3 ? 'animate__slideInRight' : 'animate__slideOutRight' ">
								<img src="@/assets/index/xt_01.png" alt="" class="img-3x" />
							</div>
					  	</div>
				  	</div>
				  	<div class="core-box" :class="{'core-selected':cur==1}">
						<div class="core-item">
							<div class="core-l animate__animated" :class="tabbarBoxFixed3 ? 'animate__slideInLeft' : 'animate__slideOutLeft'">
								<h3>“电力信息化” 平台</h3>
								<p>“电力信息化平台”已经超越了普通开关单纯合分闸的作用， 它与控制 / 保护对象
									构成一个数据节点， 实现对象各种电量 / 非电量数据的“泛在聚合”， 可以方便的检索所需的各类
									数据， 在系统后台数学分析模型支撑下， 不断挖掘这些数据所代表的开关及控制对象之间普遍存在
									的复杂联系， 实现对控制对象认知的飞跃， 进而不断提升人们生活的安全性和便利度。这个意义已
									经远超普通开关合分闸所起到的作用，因此，物联网开关是对普通开关的颠覆性变革。
								</p>
								<a href="/digitalFactory" class="core-jt"><i class="iconfont icon-jiantou"></i></a>
							</div>
							<div class="cor-r animate__animated" :class="tabbarBoxFixed3 ? 'animate__slideInRight' : 'animate__slideOutRight' ">
								<img src="@/assets/index/xt_02.png" alt="" class="img-3x" />
							</div>
						</div>
				  	</div>
					<div class="core-box" :class="{'core-selected':cur==2}">
						<div class="core-item">
							<div class="core-l animate__animated" :class="tabbarBoxFixed3 ? 'animate__slideInLeft' : 'animate__slideOutLeft'">
								<h3>“电缆安全监测” 平台</h3>
								<p>电力电缆在城市变配电系统中已广泛应用， 目前包括电力公司在内的多数企业对电缆的维护管
									理还处于计划检修阶段， 一般采用定期巡视 + 年度预防性试验的方式对电缆的运行状况进行检查。
									从经济角度和技术角度来说， 计划检修有很大的局限性， 人工巡检只能粗略观察电缆外观有无损
									伤，电缆绝缘缺陷和潜在的故障无法及时发现，定期试验须停电造成了直接和间接的经济浪费。
									据统计，电缆故障除外力意外损伤以外，90% 以上发生在电缆终端接头或中间接头处，在这两
									个重点区域在线监测电缆运行状态，是电缆故障预防的有效手段。
									局部放电是电缆内部发展性绝缘缺陷的主要衡量指标， 通常发生在绝缘介质局部电场畸变严重
									或电场强度较高的终端接头或中间接头处，在线检测二者的局放状态是电缆在线监测的重要内容。
								</p>
								<a href="/digitalFactory" class="core-jt"><i class="iconfont icon-jiantou"></i></a>
							</div>
							<div class="cor-r animate__animated"  :class="tabbarBoxFixed3 ? 'animate__slideInRight' : 'animate__slideOutRight' ">
								<img src="@/assets/index/xt_03.png" alt="" class="img-3x" />
							</div>
						</div>
				  	</div>
			  	</div>
			</div>
		</div>

		<!-- 关于企业 v-show="tabbarBoxFixed5" -->
		<div class="AboutEnterprises page5">
			<div class="AboutEnterprises_cont">
				<!-- top -->
				<div class="AboutEnterprises_cont_top">
					<!-- top_left -->
					<div class="AboutEnterprises_cont_top_left animate__animated" :class="tabbarBoxFixed5 ? 'animate__rollIn' : 'animate__rollOut'">
						<h1>关于企业</h1>
						<p>
							江西正能智慧科技有限公司(以下简称公司) 成立于 2016 年10月28日，位于江西省南昌市赣江中大道 1218 号新地中心，注册资本 20001 万元人民币，实缴资本10001 万人民币。<br />
公司业务围绕电力设备信息化、数字化应用布局，致力于电力专用软硬件系统开发、电力购销、新能源投资运营、 电力设备检测/维保等综合能源服务。公司独立开发了能源综合管理、配电房数字化、 电缆/变压器/开关设备在线监测、 物联网开关等配用电领域软硬件系统，从40.5kV变电站设备、电缆到 0.4kV 终端配电箱，公司具备全栈电力设施在线监测、 数据存储、智能运维、 故障预警等产品开发能力。
						</p>
						<router-link to="/jituangaikuo">
							<div class="AboutEnterprises_cont_top_left_btn">
								<span>了解更多</span>
								<img src="../assets/img/guanyujiantou.png" alt="" />
							</div>
						</router-link>
					</div>
					<!-- top_right -->
					<div class="AboutEnterprises_cont_top_right">
						<video autoplay loop muted=""  class=" animate__animated" :class="tabbarBoxFixed5 ? 'animate__bounce': 'animate__bounceOut'" preload>
							<source src="http://mzzh.mzzndq.cn/download/contract/986a6318ff4a4b91814cce1b51549b48.mp4">
						</video>
						<div></div>
					</div>
				</div>
				<!-- bottom -->
				<div class="AboutEnterprises_cont_bottom">
					<div class="AboutEnterprises_cont_bottom_item">
						<h1>
							<count-to v-show="tabbarBoxFixed5" :start-val="0" :end-val="tabbarBoxFixed5 ? 25 : 0 " :duration="2000" class="card-panel-num" />
						</h1>
						
						<div class="AboutEnterprises_cont_bottom_item2">
							<span>+</span>
							<p>智慧城市</p>
						</div>
					</div>
					<div class="AboutEnterprises_cont_bottom_item">
						<h1>
							<count-to v-show="tabbarBoxFixed5" :start-val="0" :end-val="tabbarBoxFixed5 ? 601 : 0 " :duration="2500" class="card-panel-num" />
						</h1>
						<div class="AboutEnterprises_cont_bottom_item2">
							<span>+</span>
							<p>智慧工厂</p>
						</div>
					</div>
					<div class="AboutEnterprises_cont_bottom_item3">
						<h1>
							<count-to v-show="tabbarBoxFixed5" :start-val="0" :end-val="tabbarBoxFixed5 ? 504 : 0 " :duration="3000" class="card-panel-num" />
						</h1>
						<div class="AboutEnterprises_cont_bottom_item4">
							<span>+</span>
							<p>智慧小区</p>
						</div>
					</div>
					<div
						class="AboutEnterprises_cont_bottom_item"
						style="border: 0; margin-right: -70px"
					>
						<h1>
							<count-to v-show="tabbarBoxFixed5" :start-val="0" :end-val="tabbarBoxFixed5 ? 202 : 0 " :duration="3500" class="card-panel-num" />
						</h1>
						<div class="AboutEnterprises_cont_bottom_item2">
							<span>+</span>
							<p>全国院校</p>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<!-- 合作伙伴 v-show="tabbarBoxFixed6"-->
		<div class="CooperativePartner page6">
			<div>
				<div class="com-title animate__animated" :class="tabbarBoxFixed6 ? 'animate__fadeInDown' : 'animate__fadeOutUp'">
					<h3>我们的客户
						<p>CORE PRODUCTS</p>
					</h3>
				</div>
				<!-- <div class="CooperativePartner_cont_center">
					<div class="CooperativePartner_cont_center_item">
						<img src="../assets/img/合作1.png" alt="" />
						<span>合作企业</span>
					</div>
					<div class="CooperativePartner_cont_center_item">
						<img src="../assets/img/合作2.png" alt="" />
						<span>合作院校</span>
					</div>
				</div> -->
				<div class="CooperativePartner_cont_bottom animate__animated" :class="tabbarBoxFixed6 ? 'animate__fadeInUp': 'animate__fadeOutDown'">
					<div
						v-for="(item, index) in logoList"
						:key="index"
						class="CooperativePartner_cont_bottom_logo"
					>
						<img :src="item.logo" alt="" />
					</div>
				</div>
			</div>
		</div>

		<!-- footer -->

		<!-- end -->
	</div>
</template>

<script>
import CountTo from 'vue-count-to'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { getListData } from '@/api/http'
import 'swiper/css/swiper.css';
// import daohang from "../components/nav.vue";
export default {
	name: "index",
	components: {
		// daohang,
		Swiper,
		SwiperSlide,
		CountTo,
	},
	data() {
		return {
			currentScroll: 0,
			tabbarBoxFixed1: false,
			tabbarBoxFixed2: false,
			tabbarBoxFixed3: false,
			tabbarBoxFixed4: false,
			tabbarBoxFixed5: false,
			tabbarBoxFixed6: false,
			cur: 0,
			swiperList1: [
                {
                    id: 1,
                    src: require('@/assets/index/device_01.jpg'),
					name: '变压器监测仪',
					introduce: '这是简介',
                },{
                    id: 2,
                    src: require('@/assets/index/sb_mccb.png'),
					name: '智能塑壳',
					introduce: '这是简介',
                },{
                    id: 3,
                    src: require('@/assets/index/yanwu.jpg'),
					name: '烟雾报警器',
					introduce: '这是简介',
                },{
                    id: 4,
                    src: require('@/assets/index/wgwd.jpg'),
					name: '网关微断',
					introduce: '这是简介',
                },{
                    id: 5,
                    src: require('@/assets/index/wndlq_img.png'),
					name: '万能断路器',
					introduce: '这是简介',
                },{
                    id: 6,
                    src: require('@/assets/index/wjzb_img_01.png'),
					name: '微机综保',
					introduce: '这是简介',
                },{
                    id: 7,
                    src: require('@/assets/index/dgnb_img.jpg'),
					name: '多功能表',
					introduce: '这是简介',
                },{
                    id: 8,
                    src: require('@/assets/index/sbgl_img_shexiangtou.png'),
					name: '摄像头',
					introduce: '这是简介',
                }
            ],
			swiperOptions2: {
                slidesPerView: 4,
				spaceBetween: 20,
				slidesPerGroup: 4,
				loop: true,
				loopFillGroupWithBlank: true,
				speed: 2500,
				// centeredSlides : true,
				// watchSlidesProgress : true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				},
				
			},
			swiperData: {
                // 自动切换
                autoplay: {
					delay: 5000,//1秒切换一次
				},
                // 环路
                loop: true,
                // 前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 分页器
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true
                },
                // 切换效果cube
                effect : 'slide',
                cubeEffect: {
                    slideShadows: true,
                    shadow: true,
                    shadowOffset: 100,
                    shadowScale: 0.7
                },
            },
            swiperListData: [
                {
                    id: 1,
                    src: require('@/assets/index/banner_05.jpg'),
					title: "用心服务  点亮美好生活",
					english: "SERVICE WITH HEART, ILLUMINATING A WONDERFUL LIFE"
                },{
                    id: 2,
                    src: require('@/assets/index/banner_02.jpg'),
					title: "用心保障  电力无忧",
					english: "CAREFULLY ENSURED POWER UNWORRIED"
                },{
                    id: 3,
                    src: require('@/assets/index/banner_03.jpg'),
					title: "电力之光  引领未来",
					english: "THE LIGHT OF POWER LEADING THE FUTURE"
                },{
                    id: 4,
                    src: require('@/assets/index/banner_04.jpg'),
					title: "连接未来  供电无忧",
					english: "CONNECTING THE EUTURE POWER SUPPLY WITHOUT WORRIES"
                },{
                    id: 5,
                    src: require('@/assets/index/banner_01.jpg'),
					title: "连接未来  供电无忧",
					english: "CONNECTING THE EUTURE POWER SUPPLY WITHOUT WORRIES"
                }
            ],
			navList: [
				{ title: "首页", url: "/" },
				{ title: "集团概括", url: "/jituangaikuo" },
				{ title: "集团产业", url: "/chanye" },
				{ title: "集团新闻", url: "/xinwen" },
				{ title: "招聘详情", url: "/zhaopinxiangqing0_0" },
				{ title: "联系我们", url: "/lianxi" },
				{ title: "招聘信息", url: "/zhaopinxinxi0" },
			],

			jituanList: [
				{
					jituanimg: require("../assets/img/jituan1.png"),
					jituanimgyinying: require("../assets/img/jituanyinying.png"),
					jituanspan: "金融产业",
					jituanp: "融资租赁  |债券融资  |  信托  |  产业基金",
				},
				{
					jituanimg: require("../assets/img/jituan1.png"),
					jituanimgyinying: require("../assets/img/jituanyinying.png"),
					jituanspan: "金融产业",
					jituanp: "融资租赁  |债券融资  |  信托  |  产业基金",
				},
				{
					jituanimg: require("../assets/img/jituan1.png"),
					jituanimgyinying: require("../assets/img/jituanyinying.png"),
					jituanspan: "金融产业",
					jituanp: "融资租赁  |债券融资  |  信托  |  产业基金",
				},
				{
					jituanimg: require("../assets/img/jituan1.png"),
					jituanimgyinying: require("../assets/img/jituanyinying.png"),
					jituanspan: "金融产业",
					jituanp: "融资租赁  |债券融资  |  信托  |  产业基金",
				},
			],
			logoList: [
				{ logo: require("../assets/index/icon_kehu_01.png") },
				{ logo: require("../assets/index/icon_kehu_02.png") },
				{ logo: require("../assets/index/icon_kehu_03.png") },
				{ logo: require("../assets/index/icon_kehu_04.png") },
				{ logo: require("../assets/index/icon_kehu_05.png") },
				{ logo: require("../assets/index/icon_kehu_06.png") },
				{ logo: require("../assets/index/icon_kehu_07.png") },
				{ logo: require("../assets/index/icon_kehu_08.png") },
				{ logo: require("../assets/index/icon_kehu_09.png") },
				{ logo: require("../assets/index/icon_kehu_10.png") },
				{ logo: require("../assets/index/icon_kehu_11.png") },
				{ logo: require("../assets/index/icon_kehu_12.png") },
				{ logo: require("../assets/index/icon_kehu_13.png") },
				{ logo: require("../assets/index/icon_kehu_14.png") },
			],
			newList: [
				{
					title: "发展数字经济 共享包容增长 为经济发展插上“数字翅膀”",
					time: "2021-05-30",
					text: "中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...",
				},
				{
					title: "用系统思维下好“职业教育一盘大棋”",
					time: "2021-05-30",
					text: "中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...",
				},
				{
					title: "我国将在全国实施动产和权利担保统一登记—拓融资渠道",
					time: "2021-05-30",
					text: "中国心理学会法律心理学分会副会长、中国人民公安大学教授李玫瑾，同时也担任中国预防青少年犯罪研究会的副会长...",
				},
			],
		};
	},
	computed: {
		title() {
			return this.$store.state.title;
		},
		
	},
	created() {
		// this.pushToBaidu();
	},
	mounted(){
		window.addEventListener('scroll', this.handleScroll);
	},
    
    beforeDestroy(){
		// window.removeEventListener('scroll', this.handleScroll)
    },

	methods: {
		async pushToBaidu() {
			getListData().then(response => {

				console.log('------查询详情------')
				// 线上
				//this.$refs['socketDetails'].showEdit(row.onOffStatus,response.data.data)

				console.log(response)

			}).catch(response => {
				console.log(response)
				this.$notify.error({
					title: '失败',
					message: "查询失败"
				})
			})
		},
		handleClick1(){
			console.log("点击跳转");
			this.$router.push("/platformDetails1");
		},
		handleScroll() {
			
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			var offsetTop1 = document.querySelector('.page1').offsetTop // 获取产品服务距离顶部的距离
			var offsetTop2 = document.querySelector('.page2').offsetTop // 获取产品服务距离顶部的距离
			var offsetTop3 = document.querySelector('.page3').offsetTop // 获取产品服务距离顶部的距离
			var offsetTop4 = document.querySelector('.page4').offsetTop // 获取产品服务距离顶部的距离
			var offsetTop5 = document.querySelector('.page5').offsetTop // 获取产品服务距离顶部的距离
			var offsetTop6 = document.querySelector('.page6').offsetTop // 获取产品服务距离顶部的距离
			
			// 滚动到一定的位置
			if (scrollTop+500 >= offsetTop1) {
				this.tabbarBoxFixed1 = true
			} 
			// else {
			// 	this.tabbarBoxFixed1 = false
			// }

			// 滚动到一定的位置
			if (scrollTop+500 >= offsetTop2) {
				this.tabbarBoxFixed2 = true
			} 
			// else {
			// 	this.tabbarBoxFixed2 = false
			// }

			
			// 滚动到一定的位置
			if (scrollTop+500 >= offsetTop3) {
				this.tabbarBoxFixed3 = true
			} 
			// else {
			// 	this.tabbarBoxFixed3 = false
			// }
			
			// 滚动到一定的位置
			if (scrollTop+500 >= offsetTop4) {
				this.tabbarBoxFixed4 = true
			} 
			// else {
			// 	this.tabbarBoxFixed4 = false
			// }
			
			// 关于我们滚动效果
			if (scrollTop+500 >= offsetTop5) {
				this.tabbarBoxFixed5 = true
			} 
			// else {
			// 	this.tabbarBoxFixed5 = false
			// }

			// 我们的客户滚动效果
			if (scrollTop+500 >= offsetTop6) {
				this.tabbarBoxFixed6 = true
			} 
			// else {
			// 	this.tabbarBoxFixed6 = false
			// }
		},
		// handleScroll() {
		// 	// 获取当前滚动位置
		// 	let _this = this
		// 	let read = _this.$el.querySelector('#read')
		// 	console.log(read.scrollToTop)
		// },
		funyuming(msg) {
			this.$router.push(msg);
		},
		newsArticle(index) {
			this.$router.push("/newsxiangqing" + index);
		},
		funRouter() {
			this.$router.push("/keji");
		},
	},
};
</script>
<style scoped>

.homepage_wrap {
	width: 100vw;
	margin: 0 auto;
	padding-top: 90px;
}
.banner-title{
	position: absolute;
	left: 15%;
	bottom: 350px;
	z-index: 1;
	color: #ffffff;
}
.banner-title h1{
	color: #ffffff;
	font-size: 52px;
}
.banner-title p{
	margin-top: 15px;
	font-size: 22px;
}
.banner_nav {
	width: 100vw;
	height: calc(100vh - 90px);
	max-height: 990px;
	position: relative;
}
.banner_nav .swiper-container{
	height: 100%;
}
.banner_nav_bg img {
	/* 文本居顶部对齐 */
	vertical-align: top;
}
/* 导航部分 */

.navWrap {
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	/*  */
	padding-top: 40px;
}

.navWrap_center {
	width: 1440px;
	height: 101px;
	margin: 0 auto;
	background: #fff;
	border-radius: 51px;
	/*  */
	display: flex;
	justify-content: space-between;
}

.navWrap_center_img {
	width: 181px;
	height: 54px;
	margin: 23px 0 0 120px;
}

.navWrap_center_img img {
	width: 181px;
}

.navWrap_center_ul {
	/* border:1px solid red; */
	margin-right: 121px;
}

.navWrap_center_ul li {
	display: inline-block;
	height: 98px;
	line-height: 98px;
	/* border-bottom: 4px solid blue; */
	margin-left: 50px;
	padding: 0 5px;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #222222;
	/* line-height: 22px; */
}
.navWrap_center_ul li:hover {
	cursor: pointer;
	color: rgba(35, 51, 127, 1);
	border-bottom: 2px solid rgba(35, 51, 127, 1);
}

/* title */

.banner_title_wrap {
	width: 100%;
	position: absolute;
	bottom: 290px;
	/* border: 1px solid yellow; */
}

.banner_title_center {
	/* border: 1px solid white; */
	text-align: center;
	width: 1200px;
	margin: 0 auto;
	font-size: 90px;
	font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
	font-weight: bold;
	color: #ffffff;
	line-height: 124px;
	letter-spacing: 1px;
}

.banner_title_center div {
	padding-top: 14px;
	font-size: 20px;
	font-family: Helvetica;
	line-height: 24px;
	letter-spacing: 4px;
}

.banner_title_center div span {
	margin: 0 18px;
}
/* news */
.news {
	width: 100vw;
	height: 801px;
	background: #f8f8f8;
}
.news_cont {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
}
.news_cont_left {
	margin-top: 89px;
}
.news_cont_left_img img {
	width: 588px;
	height: 353px;
	margin-top: 41px;
}
.news_cont_left_text {
	padding-top: 27px;
	padding-left: 40px;
	width: 548px;
	height: 150px;
	background-color: #ffffff;
}
.news_cont_left_text h1 {
	font-size: 18px;
	font-weight: 500;
	color: #23337f;
}
.news_cont_left_text p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8f8f8f;
	margin-top: 10px;
}
.news_cont_right {
	width: 588px;
	margin-top: 103px;
}
.news_cont_right_ul ul {
	font-size: 16px;
	font-weight: 400;
	color: #b3b3b3;
	line-height: 22px;
	float: right;
	display: flex;
}
.news_cont_right_ul ul a {
	font-size: 16px;
	font-weight: 400;
	color: #b3b3b3;
	line-height: 22px;
	float: right;
	display: flex;
}
.news_cont_right_ul ul li:hover {
	color: #23337f;
}
.news_cont_right_ul ul span {
	margin: 0 23px 0 24px;
}
.news_cont_right_text {
	width: 588px;
	height: 535px;
	background: #ffffff;
	margin-top: 68px;
}
.news_cont_right_text_item {
	padding: 36px;
}
.news_cont_right_text_item h1 {
	font-size: 18px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 25px;
}
.news_cont_right_text_item p {
	margin-top: 10px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8f8f8f;
	line-height: 20px;
}
.news_cont_right_text_hr {
	/* float: right; */
	width: 508px;

	border-bottom: 1px solid #d7d7d7;
}
.news_cont_right_text_hr:nth-of-type(3) {
	/* float: right; */
	width: 508px;

	border-bottom: none;
}
.news_cont_right_text_item2 {
	padding: 24px 40px;
}
.news_cont_right_text_item2 h1 {
	font-size: 18px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #444444;
	line-height: 25px;
}
.news_cont_right_text_item2 p {
	margin-top: 10px;
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #8f8f8f;
	line-height: 20px;
}
/* 集团产业 */
.GroupIndustry {
	width: 100vw;
	height: 800px;
	background: #ffffff;
}
.GroupIndustry_cont {
	width: 1200px;
	margin: 0 auto;

	display: flex;
	justify-content: space-between;
}
.GroupIndustry_cont_left_title {
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #444444;
	line-height: 50px;
	margin: 84px 0 40px 0;
}
.GroupIndustry_cont_left_img_f {
	width: 793px;

	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
}
.GroupIndustry_cont_left_img {
	margin-bottom: 24px;

	position: relative;
}
.GroupIndustry_cont_left_img img:first-child {
	width: 384px;
	height: 261px;
	background: linear-gradient(180deg, rgba(0, 100, 255, 0) 0%, #000b6e 100%);
}
.GroupIndustry_cont_left_img2 {
	position: absolute;
	left: 0;
	bottom: 0;
}

.GroupIndustry_cont_left_text {
	position: absolute;
	left: 32px;
	bottom: 18px;
}
.GroupIndustry_cont_left_text p {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
	margin-top: 10px;
}
.GroupIndustry_cont_left_text span {
	font-size: 24px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.3);
}
.GroupIndustry_cont_right {
	position: relative;
	margin-top: 98px;
}
.GroupIndustry_cont_right_title {
	float: right;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #999999;
	line-height: 22px;
	margin-bottom: 54px;
}

.GroupIndustry_cont_right_img {
	width: 384px;
	height: 546px;
}
.GroupIndustry_cont_right_img2 {
	position: absolute;
	bottom: 24px;
}
.GroupIndustry_cont_right_text {
	position: absolute;
	left: 45px;
	bottom: 45px;
}
.GroupIndustry_cont_right_text p {
	font-size: 24px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	line-height: 33px;
}
.GroupIndustry_cont_right_text span {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
}
/* 关于企业 */
.AboutEnterprises {
	width: 100vw;
	height: 856px;
	background-image: url("../assets/img/guanyu_bg.png");
	background-size: 100% 100%;
}
.AboutEnterprises_cont {
	width: 1400px;
	margin: 0 auto;
	height: 100%;
}
.AboutEnterprises_cont_top {
	display: flex;
	justify-content: space-between;
}
.AboutEnterprises_cont_top_left {
	margin-top: 143px;
	width: 60%;
	padding-right: 80px
}
.AboutEnterprises_cont_top_left > h1 {
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #ffffff;
	line-height: 50px;
}
.AboutEnterprises_cont_top_left p {
	margin-top: 36px;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 7;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 40px;
}
.AboutEnterprises_cont_top_left_btn {
	width: 160px;
	height: 40px;
	border: 1px solid rgba(255, 255, 255, 0.8);
	margin-top: 81px;
	display: flex;
	align-items: center;
}
.AboutEnterprises_cont_top_left_btn img {
	width: 24px;
	height: 24px;

	margin-left: 8px;
}
.AboutEnterprises_cont_top_left_btn span {
	margin-left: 32px;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #ffffff;
	line-height: 22px;
}
.AboutEnterprises_cont_top_right {
	position: relative;
	width: 40%;
	height: 517px;
	margin-top: 115px;
}
.AboutEnterprises_cont_top_right img {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 517px;
	display: block;
}
.AboutEnterprises_cont_top_right video {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 517px;
	display: block;
	background-color: #000000;
}
.AboutEnterprises_cont_top_right Div {
	width: 317px;
	height: 408px;
	background: #3491e5;
	position: absolute;
	top: 64px;
	left: -33px;
}
.AboutEnterprises_cont_bottom {
	display: flex;

	margin-top: 80px;
}
.AboutEnterprises_cont_bottom_item {
	margin-right: 70px;
	position: relative;
	border-right: 1px solid #ffffff;
	display: flex;
	padding-right: 30px
}
.AboutEnterprises_cont_bottom_item3 {
	margin-right: 70px;
	position: relative;
	width: 323px;
	border-right: 1px solid #ffffff;
	display: flex;
}
.AboutEnterprises_cont_bottom_item3 p {
	width: 86px;
	height: 28px;
	font-size: 20px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #b30588;
	line-height: 28px;
}
.AboutEnterprises_cont_bottom_item3 h1 {
	font-size: 60px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 84px;
}
.AboutEnterprises_cont_bottom_item3 h1 span{
	font-size: 60px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 84px;
}
.AboutEnterprises_cont_bottom_item3 span {
	font-size: 17px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #692020;
	line-height: 24px;
}
.AboutEnterprises_cont_bottom_item4 {
	position: absolute;
	left: 161px;
	bottom: 15px;
}

.AboutEnterprises_cont_bottom_item h1 {
	font-size: 60px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 84px;
}
.AboutEnterprises_cont_bottom_item h1 span{
	font-size: 60px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 84px;
}
.AboutEnterprises_cont_bottom_item span {
	font-size: 17px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #692020;
	line-height: 24px;
}
.AboutEnterprises_cont_bottom_item p {
	width: 86px;
	height: 28px;
	font-size: 20px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #b30588;
	line-height: 28px;
}

.AboutEnterprises_cont_bottom_item2 {
	margin-left: 15px;
	padding-top: 30px
}
/* 合作伙伴 */
.CooperativePartner {
	width: 100vw;
	height: 798px;
	background-image: url("../assets/img/hezuo_bg.png");
	background-size: 100% 100%;
}
.CooperativePartner_cont {
	width: 1200px;
	margin: 0 auto;
}
.CooperativePartner_cont_title {
	text-align: center;
	margin-top: 80px;
	font-size: 36px;
	font-family: PingFangSC-Semibold, PingFang SC;
	font-weight: 600;
	color: #444444;
	line-height: 50px;
}
.CooperativePartner_cont_center {
	display: flex;
	justify-content: space-between;
	width: 365px;
	height: 69px;

	margin: 0 auto;
	margin-top: 47px;
}
.CooperativePartner_cont_center_item {
	display: flex;
	align-items: center;
}
.CooperativePartner_cont_center_item:hover {
	border-bottom: 1px solid #3491e5;
}
.CooperativePartner_cont_center_item img {
	width: 40px;
	height: 40px;
}
.CooperativePartner_cont_center_item span {
	line-height: 69px;
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 33px;
	margin-left: 14px;
}
.CooperativePartner_cont_bottom {
	display: flex;
	/*justify-content: space-between;*/
	flex-wrap: wrap;
	width: 1400px;
	/*height: 392px;*/
	margin: 0 auto;
	margin-top: 80px;
}
.CooperativePartner_cont_bottom_logo{
	padding: 0 15px;
	cursor: pointer;
	filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
}
.CooperativePartner_cont_bottom_logo:hover{
	filter: none;
    -webkit-filter: none;
    -moz-filter: none;
    -ms-filter: none;
    -o-filter: none;
}

.CooperativePartner_cont_bottom_logo:hover img{
	-webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    transform: scale(1.1);
    box-shadow: 0 5px 10px rgba(0,0,0,0.2);
}

.CooperativePartner_cont_bottom_logo img {
	width: 250px;
	height: 130px;
	background: #ffffff;
	box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);
	border-radius: 9px;
	margin-bottom: 16px;
	-webkit-transition: all 0.2s ease-out 0s;
    -moz-transition: all 0.2s ease-out 0s;
    -o-transition: all 0.2s ease-out 0s;
    transition: all 0.2s ease-out 0s;
}
.dropbtn {
	background-color: #fff;
	color: rgb(12, 11, 11);
	padding: 16px;
	font-size: 16px;
	border: none;
	cursor: pointer;
}

.dropdown {
	top: 22px;
	left: 394px;
	position: relative;
	display: inline-block;
}

.dropdown-content {
	text-align: center;
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	min-width: 95px;
	min-height: 120px;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}

.dropdown-content a {
	color: rgb(6, 6, 6);
	padding: 12px 16px;
	text-decoration: none;
	display: block;
}

.dropdown-content a:hover {
	background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
	display: block;
}
</style>
